import React from "react";
import logo from "./Logo_Trickyleaf.svg";
import "./App.scss";
import { TeamSection } from "./page-parts/Team";
import { ProjectsSection } from "./page-parts/Projects";
import Particles from "./Particles";
import { ContactsSection } from "./page-parts/Contacts";
import { FooterSection } from "./page-parts/Footer";
import { ServicesSection } from "./page-parts/Services";
import { ProcessSection } from "./page-parts/Process";

function App() {
  return (
    <div className="App">
      <NavBar />
      <div className="scrollable">
        <Hero />
        <div className={"container"}>
          <ProjectsSection />
          <ServicesSection />
          <ProcessSection />
          <TeamSection />
          <ContactsSection />
        </div>
        <FooterSection />
      </div>
    </div>
  );
}

export function ArrowIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  );
}

export function Hero() {
  return (
    <section className="hero" id="top">
      <div className="hero-inner">
        <div className="hero-text">
          <h1>
            Let your business turn over a <span>new leaf.</span>
          </h1>
          <p className="hero-sub">
            A Milan-based team of mathematicians turning ideas into software products — AI, data
            and apps, from first analysis to production.
          </p>
          <div className="hero-ctas">
            <a className="btn btn-primary" href="#work">
              See our work <ArrowIcon />
            </a>
            <a className="btn btn-ghost" href="#contact">
              Talk to us
            </a>
          </div>
        </div>
        <div className="hero-visual" aria-hidden="true">
          <Particles />
          <div className="hero-formula">
            <span>f(x) = sin(x) · e<sup>−λt</sup></span>
            <span>{"// we model before we code"}</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export function NavBar() {
  return (
    <header className="navbar">
      <nav>
        <a className="brand" href="#top">
          <img src={logo} alt="" />
          <span>Trickyleaf</span>
        </a>
        <div className="nav-menu">
          <a href="#work">Work</a>
          <a href="#services">Services</a>
          <a href="#process">Process</a>
          <a href="#team">Team</a>
        </div>
        <a className="btn btn-primary btn-small" href="#contact">
          Start a project
        </a>
      </nav>
    </header>
  );
}

export default App;
